import Vue from "vue";
import Router from "vue-router";
import Login from "./views/Login.vue";
import SendMailToAdmin from "./views/SendMailToAdmin.vue";
import MainNavbar from "./layout/MainNavbar.vue";
import MainFooter from "./layout/MainFooter.vue";
import BasicElementsSection from "./views/components/BasicElementsSection.vue";
import SessionUser from "./views/components/SessionUser.vue";
import UserForCurrentMonth from "./views/components/UserForCurrentMonth.vue";
import UserForCurrentMontSelected from "./views/components/UserForCurrentMontSelected.vue";
import Aide from "./views/components/Aide.vue";
import Logout from "./views/components/Logout.vue";
import Volunteer from "./views/Volunteer/index.vue";
import ShowByAntenne from "./views/components/showByAntenne.vue";
import ShowByActivite from "./views/components/showByActivite.vue";
import download from "./views/download";
import store from "./store/auth";

Vue.use(Router);

const router = new Router({
  routes: [
    {
      path: "/",
      name: "index",
      components: { default: Login, header: MainNavbar, footer: MainFooter },
      props: {
        header: { colorOnScroll: 400 },
        footer: { backgroundColor: "black" },
      },
    },
    {
      path: "/sendMail",
      name: "sendMail",

      meta: { permissions: ["Admin", "Responsable antenne"] },
      components: {
        default: SendMailToAdmin,
        header: MainNavbar,
        footer: MainFooter,
      },
      props: {
        header: { colorOnScroll: 400 },
      },
    },

    {
      path: "/basic",
      name: "basic",
      components: {
        default: BasicElementsSection,
        header: MainNavbar,
        footer: MainFooter,
      },
    },
    {
      path: "/aide",
      name: "aide",
      meta: {
        public: true,
      },
      components: {
        default: Aide,
        header: MainNavbar,
        footer: MainFooter,
      },
    },
    {
      path: "/logout",
      name: "logout",
      meta: {
        public: true,
      },
      components: {
        default: Logout,
        header: MainNavbar,
        footer: MainFooter,
      },
    },
    {
      path: "/session",
      name: "session",
      components: {
        default: SessionUser,
        header: MainNavbar,
        footer: MainFooter,
      },
      props: {
        header: { colorOnScroll: 400 },
      },
    },
    {
      path: "/session/:id",
      name: "sessionid",
      components: {
        default: SessionUser,
        header: MainNavbar,
        footer: MainFooter,
      },
      props: {
        header: { colorOnScroll: 400 },
      },
    },
    {
      path: "/listeUnBenevole",
      name: "listeUnBenevole",
      components: {
        default: UserForCurrentMonth,
        header: MainNavbar,
        footer: MainFooter,
      },
      props: {
        header: { colorOnScroll: 400 },
      },
    },
    {
      path: "/listeUnBenevoleSelectionne/:iduser/:month/:year/:nomComplet",
      name: "listeUnBenevoleSelectionne",
      components: {
        default: UserForCurrentMontSelected,
        header: MainNavbar,
        footer: MainFooter,
      },
      props: {
        header: { colorOnScroll: 400 },
      },
    },

    {
      path: "/volunteer",
      name: "volunteer",
      meta: { permissions: ["Admin"] },
      components: {
        default: Volunteer,
        header: MainNavbar,
        footer: MainFooter,
      },
      props: {
        header: { colorOnScroll: 400 },
      },
    },
    {
      path: "/listeParAntenne",
      name: "listeParAntenne",
      meta: { permissions: ["Admin"] },
      components: {
        default: ShowByAntenne,
        header: MainNavbar,
        footer: MainFooter,
      },
      props: {
        header: { colorOnScroll: 400 },
      },
    },
    {
      path: "/listeParActivite",
      name: "listeParActivite",
      meta: { permissions: ["Admin"] },
      components: {
        default: ShowByActivite,
        header: MainNavbar,
        footer: MainFooter,
      },
      props: {
        header: { colorOnScroll: 400 },
      },
    },
    {
      path: "/download",
      name: "download",
      meta: { permissions: ["Admin"] },
      components: {
        default: download,
        header: MainNavbar,
        footer: MainFooter,
      },
      props: {
        header: { colorOnScroll: 400 },
      },
    },
  ],
  scrollBehavior: (to) => {
    if (to.hash) {
      return { selector: to.hash };
    } else {
      return { x: 0, y: 0 };
    }
  },
});

router.beforeEach((to, from, next) => {
  const isAuthenticated = store.getters.isAuthenticated;

  if (!isAuthenticated && to.name !== "index" && !to.meta.public) {
    next("/");
    return;
  }
  if (isAuthenticated && to.name === "index") {
    next("/basic");
    return;
  }

  if (to.meta.permissions && to.meta.permissions.length > 0) {
    let isAllowed;

    to.meta.permissions.forEach((permission) => {
      if (permission == store.getters.user.typeutilisateur) {
        isAllowed = true;
      }
    });

    if (!isAllowed) return next("/");
  }

  next();
});

export default router;
